// useStyles.ts
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors, FontWeight } from '../../../../assets/styles';


const pxToRem = (px: number): string => `${px / 16}rem`;

const useStyles = makeStyles((theme: Theme) => ({
  container: {},
  title: {
    fontSize: '13px !important',
    color: `${Colors.Gray} !important`,
    fontWeight: `${FontWeight.Bold} !important`,
    textTransform: 'uppercase',
    marginTop: `${pxToRem(50)} !important`,
  },
  noReports: {
    width: '100%',
    maxWidth: 488,
    margin: `${pxToRem(75)} auto`,
    textAlign: 'center',
  },
  noReportsTitle: {
    fontSize: 22,
    color: Colors.Gray6,
    fontWeight: FontWeight.Bold,
    marginBottom: 16,
  },
  noReportsDescription: {
    fontSize: 13,
    color: Colors.Gray6,
    fontWeight: FontWeight.Regular,
  },
  reportsList: {
    paddingTop: '23px',
  },
  loadMoreProgress: {
    margin: '15px 0',
  },
  moreBtn: {
    fontSize: 14,
    fontWeight: FontWeight.Bold,
    color: Colors.Blue1,
    marginBottom: 15,
  },
  spaceBottom: {
    marginBottom: 30,
  },
}));

export default useStyles;
